﻿import * as $ from 'jquery';

window.jQuery = $;
window.$ = $;
window.jquery = $;
/*
require("jquery");
window.$ = window.jQuery = $;
*/

/*
'use strict';

require('./kendo.web.js');
require('./kendo.dataviz.js');
require('./kendo.mobile.js');
require('./html-CDPyBXgE.js');
require('./kendo.dom.js');
require('./kendo.core.js');
require('./kendo.router.js');
require('./kendo.view.js');
require('./kendo.binder.js');
require('./kendo.data.js');
require('./kendo.data.odata.js');
require('./kendo.data.xml.js');
require('./kendo.fx.js');
require('./kendo.ooxml.js');
require('@progress/kendo-ooxml');
require('./mixins-DsyK3ugN.js');
require('./kendo.data.signalr.js');
require('./kendo.validator.js');
require('./kendo.userevents.js');
require('./kendo.draganddrop.js');
require('./kendo.mobile.scroller.js');
require('./kendo.groupable.js');
require('./kendo.chip.js');
require('./kendo.html.chip.js');
require('./kendo.html.base.js');
require('./kendo.icons.js');
require('./kendo.html.icon.js');
require('@progress/kendo-svg-icons');
require('./kendo.chiplist.js');
require('./kendo.html.chiplist.js');
require('./kendo.reorderable.js');
require('./kendo.resizable.js');
require('./kendo.sortable.js');
require('./kendo.selectable.js');
require('./kendo.chat.js');
require('./kendo.html.button.js');
require('./kendo.button.js');
require('./kendo.badge.js');
require('./kendo.buttongroup.js');
require('./kendo.togglebutton.js');
require('./kendo.breadcrumb.js');
require('./kendo.switch.js');
require('./kendo.pager.js');
require('./kendo.dropdownlist.js');
require('./kendo.list.js');
require('./kendo.popup.js');
require('./kendo.label.js');
require('./kendo.floatinglabel.js');
require('./kendo.actionsheet.js');
require('./dropdowns-loader-CMg_pnLB.js');
require('./kendo.virtuallist.js');
require('./valueMapper-CU-4EASG.js');
require('./kendo.notification.js');
require('./kendo.tooltip.js');
require('./kendo.calendar.js');
require('./kendo.datepicker.js');
require('./kendo.dateinput.js');
require('@progress/kendo-dateinputs-common');
require('./kendo.drawer.js');
require('./kendo.multiviewcalendar.js');
require('./kendo.autocomplete.js');
require('./prefix-suffix-containers-BmDm564f.js');
require('./kendo.dropdowntree.js');
require('./kendo.treeview.js');
require('./kendo.treeview.draganddrop.js');
require('./kendo.html.input.js');
require('./kendo.combobox.js');
require('./kendo.multiselect.js');
require('./kendo.multicolumncombobox.js');
require('./kendo.colorpicker.js');
require('./kendo.color.js');
require('@progress/kendo-drawing');
require('./kendo.slider.js');
require('./kendo.textbox.js');
require('./kendo.numerictextbox.js');
require('./kendo.columnmenu.js');
require('./kendo.tabstrip.js');
require('./kendo.filtermenu.js');
require('./kendo.pane.js');
require('./kendo.menu.js');
require('./kendo.expansionpanel.js');
require('./kendo.columnsorter.js');
require('./kendo.grid.js');
require('./kendo.editable.js');
require('./kendo.checkbox.js');
require('./kendo.toggleinputbase.js');
require('./kendo.window.js');
require('./kendo.filtercell.js');
require('./mixins-BRcvt5uK.js');
require('./kendo.dialog.js');
require('./kendo.form.js');
require('./kendo.toolbar.js');
require('./kendo.splitbutton.js');
require('./kendo.button.menu.js');
require('./kendo.dropdownbutton.js');
require('./kendo.loader.js');
require('./kendo.html.loadercontainer.js');
require('./loaderContainer-_4RtKBV7.js');
require('./kendo.listview.js');
require('./kendo.listbox.js');
require('./kendo.filebrowser.js');
require('./kendo.upload.js');
require('./kendo.progressbar.js');
require('./kendo.imagebrowser.js');
require('./kendo.editor.js');
require('./kendo.textarea.js');
require('./kendo.maskedtextbox.js');
require('./kendo.mediaplayer.js');
require('./kendo.pivot.fieldmenu.js');
require('./kendo.pivotgrid.js');
require('@progress/kendo-pivotgrid-common');
require('./kendo.filter.js');
require('./kendo.panelbar.js');
require('./kendo.responsivepanel.js');
require('./kendo.timepicker.js');
require('./kendo.datetimepicker.js');
require('./kendo.daterangepicker.js');
require('./kendo.scrollview.js');
require('./kendo.splitter.js');
require('./kendo.scheduler.view.js');
require('./kendo.scheduler.dayview.js');
require('./kendo.scheduler.agendaview.js');
require('./kendo.scheduler.monthview.js');
require('./kendo.scheduler.yearview.js');
require('./kendo.scheduler.recurrence.js');
require('./kendo.scheduler.js');
require('./kendo.scheduler.timelineview.js');
require('./kendo.gantt.data.js');
require('./kendo.treelist.js');
require('./kendo.gantt.editors.js');
require('./kendo.gantt.list.js');
require('./kendo.gantt.timeline.js');
require('./kendo.touch.js');
require('./kendo.gantt.js');
require('./kendo.timeline.js');
require('./kendo.spreadsheet.js');
require('./kendo.spreadsheet.common.js');
require('@progress/kendo-spreadsheet-common');
require('./kendo.pivot.configurator.js');
require('./kendo.ripple.js');
require('@progress/kendo-ripple');
require('./kendo.pdfviewer.js');
require('@progress/kendo-pdfviewer-common');
require('pdfjs-dist/build/pdf.worker.mjs');
require('./kendo.rating.js');
require('./kendo.filemanager.js');
require('./kendo.stepper.js');
require('./kendo.tilelayout.js');
require('./kendo.wizard.js');
require('./kendo.appbar.js');
require('./kendo.imageeditor.js');
require('./kendo.floatingactionbutton.js');
require('./kendo.inputgroupbase.js');
require('./kendo.radiogroup.js');
require('./kendo.radiobutton.js');
require('./kendo.checkboxgroup.js');
require('./kendo.bottomnavigation.js');
require('./kendo.skeletoncontainer.js');
require('./kendo.taskboard.js');
require('./kendo.captcha.js');
require('./kendo.orgchart.js');
require('./kendo.popover.js');
require('./kendo.avatar.js');
require('./kendo.circularprogressbar.js');
require('./kendo.dataviz.themes.js');
require('./kendo.dataviz.core.js');
require('@progress/kendo-charts/dist/es/core-export.js');
require('@progress/kendo-charts');
require('./kendo.signature.js');
require('./kendo.timeselector.js');
require('./kendo.timedurationpicker.js');
require('./kendo.dockmanager.js');
require('./kendo.aiprompt.js');
require('./kendo.aiprompt.views.js');
require('./kendo.propertygrid.js');
require('./kendo.dataviz.chart.js');
require('@progress/kendo-charts/dist/es/chart-export.js');
require('./kendo.dataviz.sankey.js');
require('./kendo.dataviz.gauge.js');
require('./kendo.dataviz.barcode.js');
require('./kendo.dataviz.qrcode.js');
require('./kendo.dataviz.stock.js');
require('./kendo.dataviz.sparkline.js');
require('./kendo.dataviz.map.js');
require('./kendo.dataviz.diagram.js');
require('./kendo.dataviz.treemap.js');


*/
require('../../lib/kendo-ui/2025.2.702/js/kendo.licensing.js');
require('../../lib/kendo-ui/2025.2.702/js/kendo.mobile.js');
require('../../lib/kendo-ui/2025.2.702/js/kendo.reorderable.js');
require('../../lib/kendo-ui/2025.2.702/js/kendo.html.button.js');
require('../../lib/kendo-ui/2025.2.702/js/kendo.button.js');
require('../../lib/kendo-ui/2025.2.702/js/kendo.badge.js');
require('../../lib/kendo-ui/2025.2.702/js/kendo.buttongroup.js');
require('../../lib/kendo-ui/2025.2.702/js/kendo.togglebutton.js');
require('../../lib/kendo-ui/2025.2.702/js/kendo.switch.js');
require('../../lib/kendo-ui/2025.2.702/js/kendo.notification.js');
require('../../lib/kendo-ui/2025.2.702/js/kendo.tooltip.js');
require('../../lib/kendo-ui/2025.2.702/js/kendo.calendar.js');
require('../../lib/kendo-ui/2025.2.702/js/kendo.datepicker.js');
require('../../lib/kendo-ui/2025.2.702/js/kendo.dateinput.js');
require('../../lib/kendo-ui/2025.2.702/js/kendo.autocomplete.js');
require('../../lib/kendo-ui/2025.2.702/js/kendo.combobox.js');
require('../../lib/kendo-ui/2025.2.702/js/kendo.multiselect.js');
require('../../lib/kendo-ui/2025.2.702/js/kendo.multicolumncombobox.js');
require('../../lib/kendo-ui/2025.2.702/js/kendo.colorpicker.js');
require('../../lib/kendo-ui/2025.2.702/js/kendo.color.js');
require('../../lib/kendo-ui/2025.2.702/js/kendo.slider.js');
require('../../lib/kendo-ui/2025.2.702/js/kendo.textbox.js');
require('../../lib/kendo-ui/2025.2.702/js/kendo.numerictextbox.js');
require('../../lib/kendo-ui/2025.2.702/js/kendo.window.js');
require('../../lib/kendo-ui/2025.2.702/js/kendo.filtercell.js');
require('../../lib/kendo-ui/2025.2.702/js/kendo.dialog.js');
require('../../lib/kendo-ui/2025.2.702/js/kendo.form.js');
require('../../lib/kendo-ui/2025.2.702/js/kendo.toolbar.js');
require('../../lib/kendo-ui/2025.2.702/js/kendo.splitbutton.js');
require('../../lib/kendo-ui/2025.2.702/js/kendo.button.menu.js');
require('../../lib/kendo-ui/2025.2.702/js/kendo.dropdownbutton.js');
require('../../lib/kendo-ui/2025.2.702/js/kendo.listview.js');
require('../../lib/kendo-ui/2025.2.702/js/kendo.listbox.js');
require('../../lib/kendo-ui/2025.2.702/js/kendo.filebrowser.js');
require('../../lib/kendo-ui/2025.2.702/js/kendo.upload.js');
require('../../lib/kendo-ui/2025.2.702/js/kendo.progressbar.js');
require('../../lib/kendo-ui/2025.2.702/js/kendo.editor.js');
require('../../lib/kendo-ui/2025.2.702/js/kendo.textarea.js');
require('../../lib/kendo-ui/2025.2.702/js/kendo.maskedtextbox.js');
require('../../lib/kendo-ui/2025.2.702/js/kendo.filter.js');
require('../../lib/kendo-ui/2025.2.702/js/kendo.panelbar.js');
require('../../lib/kendo-ui/2025.2.702/js/kendo.responsivepanel.js');
require('../../lib/kendo-ui/2025.2.702/js/kendo.timepicker.js');
require('../../lib/kendo-ui/2025.2.702/js/kendo.datetimepicker.js');
require('../../lib/kendo-ui/2025.2.702/js/kendo.daterangepicker.js');
require('../../lib/kendo-ui/2025.2.702/js/kendo.pdfviewer.js');
require('../../lib/kendo-ui/2025.2.702/js/kendo.grid.js');
require('../../lib/kendo-ui/2025.2.702/js/kendo.timeline.js');
require('../../lib/kendo-ui/2025.2.702/js/kendo.treelist.js');
require('@progress/kendo-pdfviewer-common');
require('pdfjs-dist/build/pdf.worker.mjs');
require("../../lib/kendo-ui/2025.2.702/js/kendo.aspnetmvc");



var kendo$1 = kendo;

module.exports = kendo$1;